module.exports = __webpack_public_path__ + "img/u50.6bdf3541.png";